import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "twin-keyvalue-form"
  }, [_c('h4', [_vm._v(_vm._s(_vm.header))]), _c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n    " + _vm._s(_vm.description) + "\n  ")]), Object.keys(_vm.deviceMeta[_vm.property] || {}).length === 0 ? _c('core-button', {
    attrs: {
      "data-cy": "btn_add_keyvalue",
      "title": _vm.$i18n_t('Common.addNew'),
      "color": _vm.color,
      "prepend-icon": "fa-plus",
      "disabled": _vm.isProductiveVersion || _vm.readonly
    },
    on: {
      "click": function ($event) {
        return _vm.addKeyValuePair();
      }
    }
  }) : _vm._e(), _vm._l(Object.keys(_vm.deviceMeta[_vm.property] || {}), function (key, i) {
    return _c(VRow, {
      key: i
    }, [_c(VCol, {
      attrs: {
        "cols": "12",
        "sm": 5,
        "md": 5,
        "lg": 5
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `input_key_${key}`,
        "value": key,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.keyLabel,
        "hide-details": "",
        "disabled": _vm.isProductiveVersion || _vm.readonly
      },
      on: {
        "keydown": _vm.handleKeyDown,
        "change": e => {
          _vm.keyValueKeyChanged(key, e);
        }
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "sm": 7,
        "md": 7,
        "lg": 7
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `input_value_${key}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.valueLabel,
        "hide-details": "",
        "disabled": _vm.isProductiveVersion || _vm.readonly
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('core-button', {
            attrs: {
              "title": _vm.$i18n_t('Common.addNew'),
              "color": _vm.color,
              "prepend-icon": "fa-plus",
              "disabled": _vm.isProductiveVersion || _vm.readonly
            },
            on: {
              "click": function ($event) {
                return _vm.addKeyValuePair();
              }
            }
          }), [_vm._v(" ")], _c('core-button', {
            attrs: {
              "title": _vm.$i18n_t('Common.delete'),
              "color": _vm.color,
              "prepend-icon": "fa-trash-alt",
              "disabled": _vm.isProductiveVersion || _vm.readonly
            },
            on: {
              "click": function ($event) {
                return _vm.removeKeyValuePair(key);
              }
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.deviceMeta[_vm.property][key].defaultValue,
        callback: function ($$v) {
          _vm.$set(_vm.deviceMeta[_vm.property][key], "defaultValue", $$v);
        },
        expression: "deviceMeta[property][key].defaultValue"
      }
    }), _c(VSwitch, {
      staticStyle: {
        "margin-top": "5px",
        "margin-left": "10px",
        "opacity": "0.7",
        "margin-bottom": "20px"
      },
      attrs: {
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "color": _vm.color,
        "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.valueRequired'),
        "input-value": false,
        "hide-details": "",
        "inset": "",
        "disabled": _vm.isProductiveVersion || _vm.readonly
      },
      model: {
        value: _vm.deviceMeta[_vm.property][key].requiredValue,
        callback: function ($$v) {
          _vm.$set(_vm.deviceMeta[_vm.property][key], "requiredValue", $$v);
        },
        expression: "deviceMeta[property][key].requiredValue"
      }
    })], 1)], 1);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };